import React from 'react';
import PropTypes from 'prop-types';
import styles from './responsive-video-overlay.scss';
import PlayButton from '../../../components/play-button/play-button';
import BuyButton from '../../../components/buy-button/buy-button';

export class ResponsiveVideoOverlay extends React.Component {
  static propTypes = {
    video: PropTypes.object.isRequired,
    channel: PropTypes.object.isRequired,
    currentSiteUser: PropTypes.object,
    showButtonsText: PropTypes.bool,
    onPlayClick: PropTypes.func,
    onBuyClick: PropTypes.func,
  };

  render() {
    const {
      video,
      channel,
      currentSiteUser,
      showButtonsText,
      onPlayClick,
      onBuyClick,
    } = this.props;
    const { publisher, title } = video;

    return (
      <div className={styles.overlay}>
        <div className={styles.content}>
          <div className={styles.publisher}>{publisher}</div>
          <div className={styles.title}>{title}</div>
          <div className={styles.buttons}>
            <PlayButton
              className={styles.button}
              video={video}
              channel={channel}
              currentSiteUser={currentSiteUser}
              showText={showButtonsText}
              onClick={onPlayClick}
            />
            <BuyButton
              className={styles.button}
              video={video}
              channel={channel}
              currentSiteUser={currentSiteUser}
              showText={showButtonsText}
              onClick={onBuyClick}
            />
          </div>
        </div>
      </div>
    );
  }
}
